import { Link } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import Carousel from "../../components/ui/Carousel";
import MediaCard from "../../components/media/MediaCard";
import arrowLeft from "../../images/arrowLeft.svg";
import arrowRight from "../../images/arrowright.svg";
import { mergeCatalog } from "../../lib/catalog";

const Arrow = ({ src }) => (
  <img src={src} alt="" aria-hidden="true" className="z-[100] mr-2 h-[40px]" />
);

/**
 * One home-page row, rendered straight from the category payload that
 * /home/categories/ already embeds.
 */
const CategoryRow = ({ category }) => {
  const items = mergeCatalog(category);
  if (items.length === 0) return null;

  const href = `category/${category.slug}`;

  return (
    <div className="relative mt-4 h-[270px] w-full sm:h-[330px] md:h-[420px]">
      <div className="flex w-full flex-row items-center justify-between px-2">
        <Link to={href}>
          <h2 className="mr-4 text-lg font-semibold leading-9 text-white">
            {category.title}
          </h2>
        </Link>
        <Link to={href}>
          <div className="flex flex-row items-center text-brand">
            <p className="text-normal font-light leading-9">همه موارد</p>
            <IoIosArrowRoundBack size={30} />
          </div>
        </Link>
      </div>

      <Carousel
        renderNext={() => <Arrow src={arrowRight} />}
        renderPrev={() => <Arrow src={arrowLeft} />}
      >
        {items.map((item) => (
          <MediaCard key={`${item.type}-${item.id}`} item={item} />
        ))}
      </Carousel>
    </div>
  );
};

export default CategoryRow;
